const scroll = element => element.scrollIntoView({ behavior: "smooth", block: "start" });

const scrollToElement = (element, direct = false) => {
  const { parentElement } = element;
  const el = parentElement && !direct ? parentElement : element;
  scroll(el);
};

export default scrollToElement;
